export default {
  GET_ALL_ADS_LIST: "GET_ALL_ADS_LIST",
  CHANGE_CONNECTED_ADS: "CHANGE_CONNECTED_ADS",
  CLEAR_CHANGE_CONNECTED_ADS_RESULT: "CLEAR_CHANGE_CONNECTED_ADS_RESULT",
};
